import React, { useState, useEffect, useRef } from 'react'

import {
	Button,
    CircularProgress,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
    IconButton,
    InputAdornment,
	Typography,
	TextField,
	MenuItem,
	Switch,
	Icon
} from '@material-ui/core'

import { TimePicker } from '@material-ui/pickers'

import { useDispatch } from 'react-redux'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'

const trim_amounts = ['Short Trim', 'Medium Trim', 'Long Trim', 'Breed Specific', 'Doodle']
const useStyles = makeStyles((theme) => ({
    currencyAdornment: {
		marginLeft: '10px',
		marginTop: '15px !important'
	},
    header: {
        marginTop: 40,
        marginBottom: 16,
        color: '#1a1a35',
        fontWeight: '800',
        fontSize: 16
    },
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '0px 24px'
	},
	checkbox: {
		'&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
			fill: '#A2A1A4'
		}
	},
    column: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    },
    colInt: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingRight: 36,
    },
    priceColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '49%',
        paddingRight: 24
    },
  
	avatar: {
		background: '#C4C4C4',
		height: '32px',
		width: '32px',
		marginTop: '12px',
		marginBottom: '12px'
	},
	textField: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: '100%',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100%'
		}
	},
    textField2: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: 100,
			marginBottom: '16px',
            width: 150
		},
		'& .MuiFilledInput-underline': {
			minWidth: 100,
            width: 150
		},
    },
    priceColumn2: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '49%',
        paddingRight: 24,
        '& .MuiTextField-root': {
			minWidth: '100% !important',
            width: '100% !important',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100% !important',
            width: '100% !important'
		}
    },
	sharingWrapper: {
		height: 56,
		width: '100%',
		padding: '0px 12px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: 6,
		background: '#F9F9F9'
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	checked: {}
}))

const EditAssignmentsDialog = (props) => {
	const classes = useStyles()
    const waiverInputRef = useRef(null)
	const dispatch = useDispatch()
    const [startTime, updateStartTime] = useState(null)
    const [startTimeOpen, setStartTimeOpen] = useState(false)
    const [duration, updateDuration] = useState()
    const [visit, setVisit] = useState({})
    const [loading, setLoading] = useState(false)
   

    const isDisabled = () => false

	let { isShown, setIsShown, pet, facility, staffList } = props

    useEffect(() => {
        if (props.visit && (!visit._id || visit._id !== props.visit._id)) {
            setVisit({ ...props.visit })
        }
    }, [props.visit])

    const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

    const saveVisit = () => {
        setLoading(true)

        let updates = {
            grooming_client_report_notes: visit.grooming_client_report_notes || '',
            grooming_team_report_notes: visit.grooming_team_report_notes || '',
            before_temp_file: visit.before_temp_file ? visit.before_temp_file : null,
            after_temp_file: visit.after_temp_file ? visit.after_temp_file : null
        }

        if (props.visit.before_photo_url && !visit.before_photo_url) updates.before_photo_url = ''
        if (props.visit.after_photo_url && !visit.after_photo_url) updates.after_photo_url = ''

        props.saveVisit(updates)

        setTimeout(() => {
            setLoading(false)
            setIsShown(false)
        }, 1200)
    }

    const renderBeforePhoto = () => {
        let value = ''
        if (visit?.before_temp_file?.name) value = visit.before_temp_file.name
        if (visit.before_photo_url) value = visit.before_photo_url
        if (!value) return null;

        return (
            <div 
                style={{ 
                    padding: 10,
                    paddingTop: 2,
                    paddingBottom: 2,
                    backgroundColor: '#F9F9F9',
                    borderRadius: 6,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: 250,
                    marginBottom: 16
                }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        width: '80%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                    >
                    <i className='fa fa-image' style={{ color: '#6B4AD6', marginRight: 8 }}/>
                    <Typography style={{ color: '#6b4ad6', fontSize: 14, fontWeight: '800' }}>{value}</Typography>
                </div>
                <IconButton
                    style={{ fontSize: 18 }}
                    onClick={() => {
                    setVisit({
                        ...visit,
                        before_photo_url: '',
                        before_temp_file: null
                    })
                }}>X</IconButton>
            </div>
        )
    }

    const renderAfterPhoto = () => {
        let value = ''
        if (visit?.after_temp_file?.name) value = visit.after_temp_file.name
        if (visit.after_photo_url) value = visit.after_photo_url
        if (!value) return null;

        return (
            <div 
                style={{ 
                    padding: 10,
                    paddingTop: 2,
                    paddingBottom: 2,
                    backgroundColor: '#F9F9F9',
                    borderRadius: 6,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: 250,
                    marginBottom: 16
                }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        width: '80%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                    >
                    <i className='fa fa-image' style={{ color: '#6B4AD6', marginRight: 8 }}/>
                    <Typography style={{ color: '#6b4ad6', fontSize: 14, fontWeight: '800' }}>{value}</Typography>
                </div>
                <IconButton
                    style={{ fontSize: 18 }}
                    onClick={() => {
                    setVisit({
                        ...visit,
                        after_photo_url: '',
                        after_temp_file: null
                    })
                }}>X</IconButton>
            </div>
        )
    }


	const uploadFile = async (e, type) => {
		try {
            if (e.target.files && e.target.files.length && e.target.files[0]) {
                let file
                file = e.target.files[0]

                if (type === 'before') {
                    setVisit({
                        ...visit,
                        before_temp_file: e.target.files[0],
                    })
                } else {
                    setVisit({
                        ...visit,
                        after_temp_file: e.target.files[0],
                    })
                }
            }
		} catch(e) {
			console.log('err...', e)
			// dispatch(showError('Error uploading image.'))
			// setImageLoading(false)
		}
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => {
				setIsShown(false)
			}}
			PaperProps={{
				style: {
					minWidth: '920px',
					maxWidth: '920px',
					width: '920px',
					padding: '24px 0px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 18,
					padding: '0px 24px'
				}}>
				EDIT REPORT
			</DialogTitle>
			<DialogContent
				style={{
					padding: '0px 24px'
				}}>
                    <div className={classes.textField}>
                        <div className={classes.column}> 
                            <TextField
                                style={{
                                    minWidth: '400px',
                                    margin: 0,
                                }}
                                label="Check-in Time"
                                variant="filled"
                                disabled
                                value={visit.checkin_time ? moment(visit.checkin_time).format('h:mm a') : '--'}
                                onChange={(e) => {}}/>
                        </div>
                        <div className={classes.column} style= {{ marginLeft: 24 }}>
                            <TextField
                                style={{
                                    minWidth: '400px',
                                    margin: 0,
                                }}
                                label="Actual Start Time"
                                variant="filled"
                                disabled
                                value={visit.grooming_actual_start_time ? moment(visit.grooming_actual_start_time).format('h:mm a') : '--'}
                                onChange={(e) => {}}/>
                        </div>
                    </div>

                    <div className={classes.textField} style={{ marginBottom: 24 }}>
                        <div className={classes.column}> 
                            <TextField
                                style={{
                                    minWidth: '400px',
                                    margin: 0,
                                }}
                                label="Actual End Time"
                                variant="filled"
                                disabled
                                value={visit.grooming_actual_end_time ? moment(visit.grooming_actual_end_time).format('h:mm a') : '--'}
                                onChange={(e) => {}}/>
                        </div>
                    </div>
	
                    <div className={classes.textField} style={{ flexDirection: 'column' }}>
                        <div className={classes.column} style={{ width: '100%' }}>
                            <Typography
                                variant="overline"
                                style={{
                                    marginBottom: 8
                                }}>
                                Report Notes For Team
                            </Typography>
                            <TextField
                                multiline
                                style={{
                                    minWidth: '400px',
                                    width: '96%',
                                    margin: 0,
                                }}
                                label="Report Notes For Team"
                                variant="filled"
                                disabled={visit?.status?.id === 5}
                                value={visit.grooming_team_report_notes}
                                type="number"
                                onChange={(e) => setVisit({ ...visit, grooming_team_report_notes: e.target.value })}/>
                                 
                        </div>
                        <div className={classes.column} style={{ width: '100%', marginTop: 24 }}>
                            <Typography
                                variant="overline"
                                style={{
                                    marginBottom: 8
                                }}>
                                Report Notes For Client
                            </Typography>
                            <TextField
                                multiline
                                style={{
                                    minWidth: '400px',
                                    width: '96%',
                                    margin: 0,
                                }}
                                label="Report Notes For Client"
                                variant="filled"
                                disabled={visit?.status?.id === 5}
                                value={visit.grooming_client_report_notes}
                                type="number"
                                onChange={(e) => setVisit({ ...visit, grooming_client_report_notes: e.target.value })}/>
                                 
                        </div>
                        <div style={{ width: '100%', marginTop: 36, marginBottom: 48, display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                            <div className={classes.colInt}>
                                <Typography
                                    variant="overline"
                                    style={{
                                        marginBottom: 8
                                    }}>
                                    Before Photo
                                </Typography>
                                {renderBeforePhoto()}
                                <Button 
                                    variant="outlined" 
                                    onClick={() => {
                                        document.getElementById('addon-image').click()
                                    }}
                                    style={{
                                        color: '#6B4AD6',
                                        borderWidth: 1,
                                        borderColor: '#6B4AD6',
                                        fontSize: 14,
                                        fontWeight: '800',
                                        paddingTop: 7
                                    }}>Upload Photo</Button>
                                <div className={classes.fileUpload}>
                                    <input
                                        hidden
                                        accept="image/*, application/pdf"
                                        className={classes.input}
                                        id={`addon-image`}
                                        type="file"
                                        ref={waiverInputRef}
                                        onChange={(e) => uploadFile(e, 'before')}
                                    />
                                </div>
                            </div>
                            <div className={classes.colInt}>
                                <Typography
                                    variant="overline"
                                    style={{
                                        marginBottom: 8
                                    }}>
                                    After Photo
                                </Typography>
                                {renderAfterPhoto()}
                                <Button 
                                    variant="outlined" 
                                    onClick={() => {
                                        document.getElementById('after-image').click()
                                    }}
                                    style={{
                                        color: '#6B4AD6',
                                        borderWidth: 1,
                                        borderColor: '#6B4AD6',
                                        fontSize: 14,
                                        fontWeight: '800',
                                        paddingTop: 7
                                    }}>Upload Photo</Button>
                                <div className={classes.fileUpload}>
                                    <input
                                        hidden
                                        accept="image/*, application/pdf"
                                        className={classes.input}
                                        id={`after-image`}
                                        type="file"
                                        ref={waiverInputRef}
                                        onChange={(e) => uploadFile(e, 'after')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						saveVisit()
					}}
					color="secondary">
					{loading ? <CircularProgress/> : 'Save'}
				</Button>
				<Button
					variant="outlined"
                    disabled={loading}
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditAssignmentsDialog
